import m from 'mithril'

export default {
  view: vnode => {
    const arc = require('./arc.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-25-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>        
          <figure className="log-book-figure">
            <img src={arc} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Isen presser det buede metaltag ned mod Camp Century's reaktor-bygning.  
            </figcaption>    
                 
          </figure>
          <h3 className="log-book-text mod-h3">Stank fra afføring</h3>

          <p className="log-book-text">Der er mange andre problemer med at drive Camp Century. Et af dem er kloakering. Afføringen fra beboerne bliver ledt direkte ned i et hul i isen, en slags brønd. Idéen er, at det derfra selv skal smelte sig vej videre ned gennem iskappen.</p>

          <p className="log-book-text">“Man valgte at etablere en kloakbrønd blot 45 meter fra en af de T-5 bygninger, der fungerede som indkvartering for personellet. Brønden var ikke ventileret, og da sommeren nærmede sig, blev lugten fra brønden næsten ulidelig. Også længere væk – i tunnelerne 18,19 og 20 – var man plaget af kloakdunsten. Efterfølgende blev brønden ventileret, og problemet blev mindre, men forsvandt aldrig helt.”</p>

          <p className="log-book-text">Uddrag fra rapporten ‘Camp Century evolution of concept and history of design, construction and performance, US Army. </p>  
        </div>
      </div>
    )
  }
}
